import React, { useEffect, useState } from "react";
import cn from "classnames";
import styled from "styled-components";

interface SkuListProp {
  skuData?: any;
}
const SkuList = (props: SkuListProp) => {
  // 현재 월에 따른 시즌 확인(cloth의 경우 시즌별 가용재고로 평균값 계산) -> SS: 3~8월, FW: 9~2월
  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth() + 1);
  const [isSS, setSS] = useState(currentMonth >= 3 && currentMonth <= 8 ? true : false);

  const skuRateData = props.skuData;
  const { real_cloth, real_cap, real_bag, real_shoe, cloth_ss, cloth_fw, cap, bag, shoe } = skuRateData;

  const getPercent = (actualStock: number, availableStock: number) => {
    const rate = !isFinite(Math.round((actualStock / availableStock) * 100)) ? 0 : Math.round((actualStock / availableStock) * 100);
    return rate;
  };

  return (
    <SkuBox>
      <div
        className={cn(
          "bg-wear",
          {
            high:
              getPercent(real_cloth, isSS === true ? cloth_ss : cloth_fw) >= 100 && getPercent(real_cloth, isSS === true ? cloth_ss : cloth_fw) < 120
                ? true
                : false,
          },
          { warning: getPercent(real_cloth, isSS === true ? cloth_ss : cloth_fw) >= 120 },
        )}
      >
        <dt>wear</dt>
        <dd>
          <span>{getPercent(real_cloth, isSS === true ? cloth_ss : cloth_fw)}</span>%
        </dd>
      </div>
      <div
        className={cn(
          "bg-cap",
          { high: getPercent(real_cap, cap) >= 100 && getPercent(real_cap, cap) < 120 ? true : false },
          { warning: getPercent(real_cap, cap) >= 120 },
        )}
      >
        <dt>cap</dt>
        <dd>
          <span>{getPercent(real_cap, cap)}</span>%
        </dd>
      </div>
      <div
        className={cn(
          "bg-bag",
          { high: getPercent(real_bag, bag) >= 100 && getPercent(real_bag, bag) < 120 ? true : false },
          { warning: getPercent(real_bag, bag) >= 120 },
        )}
      >
        <dt>bag</dt>
        <dd>
          <span>{getPercent(real_bag, bag)}</span>%
        </dd>
      </div>
      <div
        className={cn(
          "bg-shoes",
          { high: getPercent(real_shoe, shoe) >= 100 && getPercent(real_shoe, shoe) < 120 ? true : false },
          { warning: getPercent(real_shoe, shoe) >= 120 },
        )}
      >
        <dt>shoes</dt>
        <dd>
          <span>{getPercent(real_shoe, shoe)}</span>%
        </dd>
      </div>
    </SkuBox>
  );
};

const SkuBox = styled.dl`
  margin-top: 10px;
  ${({ theme }) => theme.flexBox.flexMixin("row", "space-around", "center")}
  > div {
    position: relative;
    ${({ theme }) => theme.flexBox.flexMixin("column", "center", "flex-start")}
    flex: 1;
    height: 45px;
    padding-left: 18px;
    margin-left: 15px;
    color: ${({ theme }) => theme.color.secondary};
    font-size: 12px;
    text-align: left;
    dt {
      margin-bottom: 3px;
      font-weight: 500;
      text-transform: uppercase;
    }
    dd {
      > span {
        font-family: "Poppins";
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
      }
    }
    &:first-child {
      margin-left: 0;
    }
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      display: inline-block;
      width: 1.5px;
      height: 100%;
      border-radius: 3px;
      background-color: #8c96aa;
    }
    &.high {
      color: ${({ theme }) => theme.color.subMain};
      &::before {
        background-color: ${({ theme }) => theme.color.subMain};
      }
    }
    &.warning {
      color: ${({ theme }) => theme.color.warning};
      &::before {
        background-color: ${({ theme }) => theme.color.warning};
      }
    }
  }
`;

export default SkuList;
